import { Button } from "@/components/elements/Button";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { TRegisterCompleteQuery } from "@/features/auth/types/registerCompleteQuery";
import { AppRoutes } from "@/routes/config";
import { createUrlWithParams, getQueryFromURL } from "@/utils/url";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type TRegisterCompletePageProps = {};

export const RegisterCompletePage: FC<TRegisterCompletePageProps> = () => {
  const navigate = useNavigate();
  const query = getQueryFromURL<TRegisterCompleteQuery>();

  const handleGoToLogin = () => {
    if (query) {
      const { email, ownerId } = query;
      const url = createUrlWithParams(AppRoutes.login, { email, ownerId });
      navigate(url);
    } else {
      navigate(AppRoutes.login);
    }
  };

  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワードの登録完了</Typography>
      <Typography variant="body14" width={400} color={"#5A6063"}>
        パスワードの登録が完了しました。
      </Typography>
      <Button type="submit" variant="primary" fullWidth onClick={handleGoToLogin}>
        ログイン画面へ
      </Button>
    </Stack>
  );
};
